import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Buttons, CancelButton, Icon, ModalCard, TooltipButton as DTooltipButton } from '~/components';
import { colors } from '~/styles';
import MemberAssociationsList from './MemberAssociationsList';
import useMemberAssociations from './useMemberAssociations';
import { PageLoader } from '~/routes/public/pages';

const TooltipButton = styled(DTooltipButton)`
  display: flex;
  width: 107.25px;
  align-self: flex-end;
  margin-top: 0.25rem;
`;

const LoadingWrapper = styled.div`
  padding: 2rem 0;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ModalBody = styled(ModalCard.Body)`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;
  gap: 0.6rem;
`;

function DeactivateMemberConfirmation({ memberId, workspaceId, resolve, title = 'Deactivate Member' }) {
  const { data, isReady, isNotEmpty, copyToClipboard } = useMemberAssociations({ memberId, workspaceId });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);

    await resolve(true);
  };

  return (
    <ModalCard title={title} onClose={() => resolve(false)}>
      <ModalBody>
        Are you sure you want to deactivate this member? Once deactivated, the member will no longer have access to the
        workspace. Any unused portion of prepaid fees for this member will be credited to your Ruddr account.
        {!isReady ? (
          <LoadingWrapper>
            <PageLoader />
          </LoadingWrapper>
        ) : isNotEmpty ? (
          <MemberAssociationsList data={data} />
        ) : null}
      </ModalBody>

      <ModalCard.Footer>
        <ButtonsContainer>
          {isNotEmpty ? (
            <TooltipButton onClick={copyToClipboard} tooltip="Copy to clipboard">
              <Icon color={colors.white} icon="clipboard" />
            </TooltipButton>
          ) : null}
          <Buttons align="right">
            <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
            <Button isLoading={isLoading} onClick={handleSubmit}>
              OK
            </Button>
          </Buttons>
        </ButtonsContainer>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default DeactivateMemberConfirmation;
